import { createContext, Dispatch, SetStateAction } from 'react';

export type AutomationColumnId =
  | 'name'
  | 'customObjectName'
  | 'status'
  | 'numberActive'
  | 'numberPaused'
  | 'numberCompleted'
  | 'type'
  | 'created';

export const minColumnWidth = {
  name: 210,
  customObjectName: 140,
  status: 60,
  numberActive: 50,
  numberPaused: 50,
  numberCompleted: 50,
  type: 50,
  created: 70,
};

export const defaultColumnsConfig = {
  name: { width: 265 },
  customObjectName: { width: 140 },
  status: { width: 90 },
  numberActive: { width: 72 },
  numberPaused: { width: 79 },
  numberCompleted: { width: 102 },
  type: { width: 71 },
  created: { width: 145 },
};

export const CELL_PADDING = 40;

type ColumnsConfig = Record<AutomationColumnId, { width: number }>;

type ColumnsContext = {
  columnsConfig: ColumnsConfig;
  setColumnsConfig: Dispatch<SetStateAction<ColumnsConfig>>;
  resizing: AutomationColumnId | null;
  setResizing: Dispatch<SetStateAction<AutomationColumnId | null>>;
};

export const ColumnsContext = createContext<ColumnsContext>({
  columnsConfig: defaultColumnsConfig,
  setColumnsConfig: () => null,
  resizing: null,
  setResizing: () => null,
});
